export const useEnvironment = () => {
  const host = process.env.REACT_APP_APIHOST || '';
  const saasLocalHost = process.env.REACT_APP_SAAS_LOCALHOST || '';
  const saasHost = process.env.REACT_APP_SAAS_HOST || '';

  return {
    host,
    saasHost,
    saasLocalHost,
  };
};
